export default {
  app: {
    privacy: {
      policy: 'นโยบายความเป็นส่วนตัว',
      expansive: 'โดยการใช้ Expansive คุณยอมรับ {action} ของ Expansive',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'เซสชันหมดอายุ',
    sessionExpiredDescription:
      'เซสชันของคุณหมดอายุแล้ว กรุณาเข้าสู่ระบบอีกครั้งเพื่อใช้งานแอปพลิเคชันต่อ',
  },
  components: {
    appContainer: {
      chooseLanguage: 'เลือกภาษา',
      chooseLanguageDescription:
        'เลือกภาษาที่คุณต้องการสำหรับแอปพลิเคชัน ซึ่งจะเปลี่ยนภาษาของอินเทอร์เฟซและเนื้อหา',
    },
    userSelection: {
      cancel: 'ยกเลิก',
      createNewUser: 'ไม่มีชื่อของพวกเขาในรายการ',
      newUser: 'ผู้ใช้ใหม่',
      selectAnExistingUser: 'เลือกผู้ใช้ที่มีอยู่',
      selectUserHint: 'เลือกผู้ใช้ที่มีอยู่หรือสร้างใหม่เพื่อดำเนินการต่อ',
      startTypingToSearch: 'เริ่มพิมพ์เพื่อค้นหา...',
    },
    verification: {
      codeVerification: {
        continue: 'ดำเนินการต่อ',
        header: 'กรอกรหัสเข้าถึงไซต์',
        invalidCode: 'รหัสไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง',
      },
      geoVerification: {
        continueWithoutVerifying: 'ดำเนินการต่อโดยไม่ยืนยันตำแหน่ง',
        enterSiteAccessCode: 'กรอกรหัสเข้าถึงไซต์',
        locationNotEnabledOrAvailable: 'ทำไมฉันจึงเห็นสิ่งนี้?',
        notAvailable: {
          description: 'ตำแหน่ง GPS ไม่รองรับในอุปกรณ์นี้',
          header: 'ตำแหน่งไม่ได้รับการสนับสนุน',
        },
        notEnabled: {
          description: 'บริการตำแหน่งไม่ได้เปิดใช้งานหรือไม่ได้รับอนุญาต',
          header: 'ตำแหน่งไม่ได้เปิดใช้งาน',
        },
        notVerified: {
          description: 'GPS ระบุว่าคุณไม่ได้อยู่ในไซต์',
          header: 'ไม่สามารถยืนยันตำแหน่ง',
        },
        tryAgain: 'ลองใหม่อีกครั้ง',
        unavailable: {
          description: 'เราไม่สามารถยืนยันตำแหน่ง GPS ของคุณได้',
          header: 'ไม่พบตำแหน่ง',
        },
        unknown: {
          description: 'เราไม่สามารถระบุตำแหน่งของคุณได้',
          header: 'ไม่ทราบตำแหน่ง',
        },
        verified: {
          description: 'GPS ระบุว่าคุณอยู่ในไซต์',
          header: 'ตำแหน่งที่ยืนยันแล้ว',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'ไม่พบทรัพย์สิน',
        emptyDescription: 'ไม่มีทรัพย์สินที่เกี่ยวข้องกับคำสั่งงานนี้',
        warrantyParts: 'การรับประกันชิ้นส่วนหมดอายุ',
        serialNumber: 'หมายเลขประจำเครื่อง',
        none: '<ไม่มี>',
      },
      updates: {
        emptyTitle: 'ไม่พบการอัปเดต',
        emptyDescription: 'ไม่มีการอัปเดตสำหรับคำสั่งงานนี้',
        unknownUser: 'ไม่ทราบชื่อผู้ใช้',
        none: 'ไม่มี',
        addComment: {
          buttonLabel: 'เพิ่มความคิดเห็น',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'อันตราย',
          no: 'ไม่',
          yes: 'ใช่',
        },
      },
    },
    attachmentsList: {
      attachments: 'ไฟล์แนบ',
      documents: 'เอกสาร',
      siteDocuments: 'เอกสารไซต์',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'อันตราย',
        induction: 'การปฐมนิเทศ',
        safeToProceed: 'ปลอดภัยที่จะดำเนินการต่อ',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'วันที่ครบกำหนด',
        activeSessions: 'เซสชันที่ใช้งานอยู่',
        activeSessionsDescription:
          'คุณได้เช็คอินในคำสั่งงานต่อไปนี้แล้ว คุณต้องเช็คเอาท์จากคำสั่งงานเหล่านี้ก่อนที่จะเช็คอินในคำสั่งงานใหม่',
        resumeSession: 'ดำเนินการต่อ',
        startTime: 'เริ่มเมื่อ',
        unexpectedErrorTitle: 'เกิดข้อผิดพลาดที่ไม่คาดคิด',
        unexpectedErrorMessage:
          'เกิดข้อผิดพลาดที่ไม่คาดคิดขณะพยายามสร้างเซสชันของคุณ กรุณาลองอีกครั้งในภายหลัง',
        engineerNotFound: 'ไม่พบวิศวกร',
        engineerNotFoundDescription:
          'วิศวกรที่คุณพยายามเช็คอินไม่พบในระบบ กรุณาติดต่อผู้ดูแลระบบของคุณ',
      },
      verification: {
        code: {
          description: 'ในการเช็คอิน กรุณาขอรหัส 4 หลักจากผู้จัดการไซต์หรือผู้ติดต่อที่กำหนด',
        },
        geo: {
          continue: 'ดำเนินการต่อ',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'กรุณาขอรหัสผ่านจากผู้จัดการสถานที่หรือผู้ติดต่อที่กำหนดเพื่อให้การเยี่ยมชมของคุณเสร็จสมบูรณ์',
            checkOut: 'เช็คเอาท์',
            completeBeforeLeaving: 'กรุณากรอกแบบฟอร์มต่อไปนี้ก่อนออกจากระบบ',
            continue: 'ดำเนินการต่อ',
            noResolutionSelected: 'กรุณาเลือกวิธีการแก้ไขก่อนดำเนินการต่อ',
            quoteRequired: {
              hint: 'เยี่ยมชมเสร็จสิ้น รอใบเสนอราคา',
              label: 'ต้องการใบเสนอราคา',
            },
            returnVisitRequired: {
              hint: 'เราจะกลับมาอีกครั้งเพื่อทำให้เสร็จ',
              label: 'ต้องการการเยี่ยมชมครั้งถัดไป',
            },
            serviceCompleted: {
              hint: 'ไม่ต้องดำเนินการเพิ่มเติม',
              label: 'บริการเสร็จสมบูรณ์',
            },
            uploadCheckout: 'อัปโหลดไฟล์ รูปภาพ หรือวิดีโอ',
            visitNotes: 'หมายเหตุการเยี่ยมชม',
            workOrderResolution: 'การแก้ไขคำสั่งงาน',
            enterNotes: 'กรอกหมายเหตุที่นี่...',
            errors: {
              timedOut: 'หมดเวลา เกิน 30 วินาที กรุณาลองใหม่อีกครั้ง',
              closingSession: 'เกิดข้อผิดพลาดขณะปิดเซสชัน',
            },
          },
          success: {
            description:
              'ขอบคุณที่เยี่ยมชม {site} | {site} ยังมีคำสั่งงานที่เปิดอยู่ 1 รายการ | {site} ยังมีคำสั่งงานที่เปิดอยู่ {count} รายการ',
            endVisit: 'สิ้นสุดการเยี่ยมชม',
            header: 'คุณได้เช็คเอาท์สำเร็จแล้ว',
            viewWorkOrders: 'เช็คอินในคำสั่งงานอื่น',
          },
          verification: {
            code: {
              description: 'ในการเช็คเอาท์ กรุณาขอรหัส 4 หลักจากผู้จัดการไซต์หรือผู้ติดต่อที่กำหนด',
              continue: 'ดำเนินการต่อ',
            },
            geo: {
              checkOut: 'เช็คเอาท์',
              continue: 'ดำเนินการต่อ',
            },
          },
        },
        detail: {
          assets: 'ทรัพย์สิน',
          call: 'โทร',
          checkOut: 'เช็คเอาท์',
          closed: 'ปิด',
          details: 'รายละเอียด',
          dueBy: 'วันที่ครบกำหนด',
          manageEngineers: 'จัดการวิศวกร',
          notAvailable: 'ไม่สามารถใช้งานได้',
          pointOfContact: 'ผู้ติดต่อ',
          siteAccessTimes: 'เวลาที่เข้าถึงไซต์',
          siteAccessInstructions: 'คำแนะนำการเข้าถึง',
          siteAddress: 'ที่อยู่ไซต์',
          siteNotes: 'หมายเหตุไซต์',
          siteTelephone: 'โทรศัพท์ไซต์',
          siteLocation: 'ตำแหน่งที่ตั้งไซต์',
          updates: 'การอัปเดต',
          more: 'เพิ่มเติม',
          mismatchErrorTitle: 'ข้อผิดพลาดของคำสั่งงาน',
          mismatchErrorMessage:
            'คำสั่งงานที่คุณพยายามเข้าถึงไม่ตรงกับคำสั่งงานที่คุณเช็คอินอยู่ กรุณาตรวจสอบคำสั่งงานของคุณและลองอีกครั้ง',
          siteDocuments: 'เอกสารไซต์',
          validFrom: 'มีผลตั้งแต่',
          validUntil: 'หมดอายุ',
          documentName: 'ชื่อเอกสาร',
          documentType: 'ประเภทเอกสาร',
          attachments: 'ไฟล์คำสั่งงาน',
          download: 'ดาวน์โหลด',
          workDetails: 'รายละเอียดงาน',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'เพิ่มวิศวกรผู้ช่วย',
            assistantEngineers: 'วิศวกรผู้ช่วย',
            description: 'ด้วยเหตุผลด้านความปลอดภัย กรุณาระบุชื่อของวิศวกรแต่ละคนที่อยู่ในไซต์',
            editMainEngineer: 'แก้ไขวิศวกรหลัก',
            errors: {
              creatingEngineer: 'เกิดข้อผิดพลาดขณะสร้างวิศวกร',
              creatingSession: 'เกิดข้อผิดพลาดขณะสร้างเซสชัน',
            },
            header: 'วิศวกรที่ไซต์',
            mainEngineer: 'วิศวกรหลัก',
            newAssistantEngineer: 'กรอกชื่อ-นามสกุล',
            next: 'ถัดไป',
            removeEngineer: 'ลบวิศวกร',
            selectExistingAssistantEngineer: 'เริ่มพิมพ์ชื่อของพวกเขา',
          },
          index: {
            description: 'ด้วยเหตุผลด้านความปลอดภัย กรุณาระบุชื่อของวิศวกรแต่ละคนที่อยู่ในไซต์',
            errorCreatingEngineer: 'เกิดข้อผิดพลาดขณะสร้างวิศวกร กรุณาลองอีกครั้ง',
            header: 'วิศวกรที่ไซต์',
            hintMainEngineer: 'กรอกชื่อ-นามสกุลของวิศวกรหลัก',
            newMainEngineer: 'วิศวกรหลักคนใหม่',
            next: 'ถัดไป',
            selectExistingMainEngineer: 'เลือกวิศวกรหลักที่มีอยู่',
            yes: 'ใช่',
            no: 'ไม่',
            mainEngineerLabel: 'คุณคือวิศวกรหลักใช่ไหม?',
          },
        },
        index: {
          callUsOn: 'โทรหาเราที่ {phoneNumber}',
          description: 'ไม่สามารถค้นหาสิ่งที่คุณกำลังมองหา?',
          dueBy: 'วันที่ครบกำหนด',
          header: 'เลือกคำสั่งงาน',
          notAvailable: 'ไม่สามารถใช้งานได้',
          searchWorkOrders: 'ค้นหาคำสั่งงาน...',
        },
        manageEngineers: {
          manageEngineers: 'จัดการวิศวกร',
          notWorking: 'คนงานที่ไม่ทำงาน',
          pause: 'หยุดชั่วคราว',
          resume: 'ดำเนินการต่อ',
          workingNow: 'คนงานที่ทำงานอยู่',
          startTime: 'เวลาเริ่มต้น',
          endTime: 'เวลาสิ้นสุด',
          duration: 'ระยะเวลา',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'ข้อเสนอแนะแนวทาง',
            feedbackDescription:
              'กรุณาให้ข้อเสนอแนะแนวทางเกี่ยวกับคำสั่งงานเพื่อช่วยให้เราปรับปรุงบริการของเรา',
            feedbackLabel: 'ข้อเสนอแนะแนวทาง',
            filesLabel: 'ไฟล์แนบ',
            submissionLabel: 'ส่งข้อเสนอแนะแนวทาง',
          },
          hazards: {
            back: 'กลับ',
            hazards: 'อันตราย',
            next: 'ถัดไป',
            no: 'ไม่',
            noTasksForHazard: 'ไม่มีงานที่ต้องทำสำหรับอันตรายนี้',
            yes: 'ใช่',
          },
          induction: {
            continue: 'ดำเนินการต่อ',
            induction: 'การปฐมนิเทศ',
          },
          index: {
            checkIn: 'เช็คอิน',
            description: 'กรุณากรอกการประเมินความเสี่ยงสำหรับงานที่เลือก',
            fail: 'ไม่สามารถประมวลผลการตรวจสอบเริ่มงานได้',
            haltMessage:
              'ตรวจพบความเสี่ยงที่อาจเกิดขึ้น กรุณาหยุดงาน ตรวจสอบแนวทางความปลอดภัย และติดต่อผู้ดูแลระบบของคุณเพื่อขอคำแนะนำเพิ่มเติม',
            header: 'การตรวจสอบเริ่มงาน',
            endVisit: 'สิ้นสุดการเยี่ยมชม',
            leaveFeedback: 'ให้ข้อเสนอแนะแนวทาง',
          },
          safeToProceed: {
            continue: 'ดำเนินการต่อ',
            safeToProceed: 'ปลอดภัยที่จะดำเนินการต่อ',
          },
        },
      },
    },
    index: {
      title: 'ยินดีต้อนรับ',
      description: 'สแกนรหัส QR ที่ตำแหน่งของคุณเพื่อเริ่มต้น',
    },
    login: {
      errorTitle: 'ข้อผิดพลาดที่ไม่คาดคิด',
      errorMessage: 'เกิดข้อผิดพลาดที่ไม่คาดคิด กรุณาลองสแกนรหัส QR อีกครั้ง',
    },
    unauthenticated: {
      welcome: {
        title: 'ยินดีต้อนรับสู่ {site}',
        description:
          'ก่อนที่เราจะแสดงคำสั่งงานให้คุณเห็น เราจำเป็นต้องตรวจสอบรายละเอียดของคุณ คลิกปุ่มด้านล่างเพื่อดำเนินการต่อ',
        next: 'ดำเนินการต่อ',
      },
      index: {
        errorTitle: 'ข้อผิดพลาดที่ไม่คาดคิด',
        errorMessage: 'เกิดข้อผิดพลาดที่ไม่คาดคิด กรุณาลองสแกนรหัส QR อีกครั้ง',
      },
      contractor: {
        title: 'คุณทำงานให้กับใคร?',
        contractor: 'ผู้รับเหมา',
        contractorLabel: 'เริ่มพิมพ์ชื่อบริษัทของคุณ',
        contractorHint: 'คุณต้องกรอก 3 ตัวอักษรขึ้นไปเพื่อดูผลลัพธ์',
        defaultSelectPlaceholder: '--กรุณาเลือก--',
        next: 'ถัดไป',
      },
      user: {
        title: 'คุณคือใคร?',
        cancel: 'ยกเลิก',
        createNewUserLabel: 'ชื่อของฉันไม่มีในรายการ',
        existingUserLabel: 'เริ่มพิมพ์ชื่อของคุณ',
        existingUserHint: 'คุณต้องกรอก 3 ตัวอักษรขึ้นไปเพื่อดูผลลัพธ์',
        newUserLabel: 'กรอกชื่อ-นามสกุลของคุณ',
        next: 'ถัดไป',
        user: 'ผู้ใช้',
      },
      verification: {
        methods: {
          add: {
            add: 'เพิ่มวิธีการตรวจสอบ',
            defaultSelectPlaceholder: '--กรุณาเลือก--',
            emailLabel: 'อีเมล',
            existingMethodWarning:
              'คุณมีคำขอที่รอดำเนินการสำหรับวิธีการตรวจสอบนี้อยู่แล้ว การเพิ่มวิธีใหม่จะทำให้คำขอก่อนหน้านี้ถูกแทนที่',
            method: 'วิธีการ',
            methodLabel: 'วิธีการ',
            mobileCountryHint: 'กรุณาเลือกรหัสประเทศของคุณ',
            mobileCountryLabel: 'รหัสประเทศมือถือ',
            mobileHint: 'กรุณากรอกหมายเลขมือถือของคุณ',
            mobileLabel: 'มือถือ',
            title: 'เพิ่มวิธีการตรวจสอบ',
          },
          confirm: {
            confirm: 'ยืนยัน',
            description: 'กรุณายืนยันวิธีการตรวจสอบของคุณเพื่อดำเนินการต่อ',
            label: 'กรอกรหัสของคุณ',
            resend: 'ส่งรหัสใหม่',
            resendPrompt: 'ไม่ได้รับรหัสใช่ไหม?',
            title: 'ยืนยันวิธีการตรวจสอบ',
          },
          confirmed: {
            description:
              'คุณจะได้รับการแจ้งเตือนเมื่อวิธีการตรวจสอบนี้ได้รับการอนุมัติจากผู้ดูแลระบบของคุณ และจากนั้นคุณสามารถเริ่มใช้งานได้เพื่อยืนยันตัวตนของคุณ',
            forceApproval: 'จนกว่าจะได้รับการอนุมัติ คุณจะไม่สามารถเข้าถึงคำสั่งงานได้',
            nonForceApproval:
              'ในระหว่างนี้ คุณสามารถเข้าถึงคำสั่งงานได้ต่อไปโดยมีการเข้าถึงที่ลดลง',
            nonForceApprovalButtonLabel: 'ดำเนินการต่อด้วยการเข้าถึงที่ลดลง',
            title: 'รอการอนุมัติ',
          },
          addNew: 'เพิ่มวิธีการตรวจสอบใหม่',
          description:
            'เราจำเป็นต้องตรวจสอบตัวตนของคุณเพื่อให้คุณสามารถเข้าถึงคำสั่งงานได้อย่างเต็มที่',
          email: 'อีเมล',
          hint: 'เราจะส่งลิงก์ไปยังวิธีการตรวจสอบที่คุณเลือกซึ่งจะให้คุณเข้าถึงคำสั่งงานได้อย่างเต็มที่ หากคุณต้องการเปลี่ยนแปลงวิธีการตรวจสอบที่มีอยู่ กรุณาติดต่อผู้ดูแลระบบของคุณ',
          label: 'เลือกวิธีการตรวจสอบ',
          next: 'ถัดไป',
          pendingHint: 'รอการอนุมัติจากผู้ดูแลระบบของคุณ',
          sms: 'SMS',
          title: 'การตรวจสอบ',
        },
        optional: {
          hint: 'การตรวจสอบรายละเอียดผู้ใช้ของคุณจะทำให้คุณเข้าถึงคำสั่งงานได้อย่างเต็มที่',
          label: 'คุณต้องการตรวจสอบรายละเอียดผู้ใช้ของคุณหรือไม่?',
          next: 'ถัดไป',
          no: 'ไม่',
          noHint:
            'ฉันไม่ต้องการตรวจสอบรายละเอียดผู้ใช้ของฉันและดำเนินการต่อด้วยการเข้าถึงคำสั่งงานที่ลดลง',
          title: 'การตรวจสอบ',
          yes: 'ใช่',
          yesHint: 'ฉันต้องการตรวจสอบรายละเอียดผู้ใช้ของฉันและเข้าถึงคำสั่งงานได้อย่างเต็มที่',
        },
        sent: {
          description:
            'ลิงก์เข้าสู่ระบบได้ถูกส่งไปยัง {identifier} กรุณาคลิกลิงก์เพื่อทำการเข้าสู่ระบบให้เสร็จสิ้น',
          title: 'ลิงก์เข้าสู่ระบบถูกส่งแล้ว',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'เมื่อวานนี้',
      today: 'วันนี้',
      days: {
        monday: 'วันจันทร์',
        tuesday: 'วันอังคาร',
        wednesday: 'วันพุธ',
        thursday: 'วันพฤหัสบดี',
        friday: 'วันศุกร์',
        saturday: 'วันเสาร์',
        sunday: 'วันอาทิตย์',
      },
      months: {
        january: 'มกราคม',
        february: 'กุมภาพันธ์',
        march: 'มีนาคม',
        april: 'เมษายน',
        may: 'พฤษภาคม',
        june: 'มิถุนายน',
        july: 'กรกฎาคม',
        august: 'สิงหาคม',
        september: 'กันยายน',
        october: 'ตุลาคม',
        november: 'พฤศจิกายน',
        december: 'ธันวาคม',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'เกิดข้อผิดพลาด',
      message: 'กรุณาลองสแกนรหัส QR อีกครั้ง',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'ไม่ทราบชื่อผู้ใช้',
      },
      none: 'ไม่มี',
      types: {
        stateTransition: 'สถานะเปลี่ยนแปลง',
        contractorAssigned: 'ผู้รับเหมาได้รับมอบหมาย',
        engineerAssigned: 'วิศวกรได้รับมอบหมาย',
        serviceAssigned: 'บริการได้รับมอบหมาย',
        priorityChanged: 'ความสำคัญเปลี่ยนแปลง',
        actionableDateChanged: 'วันที่ดำเนินการเปลี่ยนแปลง',
        dueDateChanged: 'วันกำหนดส่งเปลี่ยนแปลง',
        etaDateChanged: 'วันและเวลาที่คาดว่าจะถึงเปลี่ยนแปลง',
        spendLimitApproved: 'วงเงินใช้จ่ายได้รับการอนุมัติ',
        spendLimitCancelled: 'คำขอวงเงินใช้จ่ายถูกยกเลิก',
        spendLimitRejected: 'วงเงินใช้จ่ายถูกปฏิเสธ',
        spendLimitRequested: 'คำขอวงเงินใช้จ่ายถูกส่ง',
        jobSheetUploaded: 'อัปโหลดใบงาน',
        slaAlertSent: 'ส่งการแจ้งเตือน SLA ที่ต้องดำเนินการ',
        issuedWorkPermit: 'ออกใบอนุญาตทำงาน',
        requestForServiceSent: 'ส่งคำขอรับบริการ',
        comment: 'เพิ่มความคิดเห็น',
        unknown: 'เหตุการณ์ที่ไม่ทราบ',
      },
      labels: {
        actionableDate: 'วันที่ดำเนินการ',
        comment: 'ความคิดเห็น',
        file: 'ไฟล์',
        contractor: 'ผู้รับเหมา',
        dueDate: 'วันกำหนดส่ง',
        etaDate: 'วันและเวลาที่คาดว่าจะถึง',
        engineer: 'วิศวกร',
        priority: 'ความสำคัญ',
        requestForService: 'คำขอรับบริการ',
        service: 'บริการ',
        spendLimit: 'วงเงินใช้จ่าย',
        status: 'สถานะ',
        workPermit: 'ใบอนุญาตทำงาน',
      },
    },
  },
}
